import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface PoultrySearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const PoultrySearch = ({ searchQuery, setSearchQuery }: PoultrySearchProps) => {
  return (
    <div className="relative mt-4">
      <Input
        type="text"
        placeholder="Rechercher par race, âge, santé..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-8"
      />
      <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
    </div>
  );
};